export default __webpack_public_path__ + "static/media/card2.d622fec8.png";